<!--
* @description  参数1
* @fileName  shipmentCharges
* @author userName
* @date 2024-01-29 14:50:44
!-->
<template>
  <div id="shipmentCharges" class="shipmentCharges">

    <div class="card-mian">
      <div class="card-item">
        <div class="card-name">总费用</div>
        <div class="card-value">CNY ￥{{ billData.totalCost }}</div>
      </div>
      <div class="card-item">
        <div class="card-name">已支付</div>
        <div class="card-value">CNY ￥{{ billData.totalPaid }}</div>
      </div>
      <div class="card-item">
        <div class="card-name">未支付</div>
        <div class="card-value">CNY ￥{{ billData.totalDue }}</div>
      </div>
    </div>
    <div class="title-class">费用明细</div>
    <div class="list-main">
      <table>
        <tr>
          <td>日期</td>
          <td>费用类型</td>
          <td>描述</td>
          <td>费用</td>
        </tr>
        <tr v-for="(item,index) in billData.billList" :key="index">
          <td>{{ item.billDate }}</td>
          <td>{{ item.chargeType }}</td>
          <td>{{ item.description }}</td>
          <td> CNY ￥{{ item.amount }}</td>
        </tr>
      </table>
      <div class="total-main">
        <div class="total">合计: CNY ￥{{ billData.totalCost }}</div>
      </div>
    </div>
    <!--    <div class="total-main">
      <div class="total">总费用: CNY ￥{{ billData.totalCost }}</div>
    </div> -->
  </div>
</template>

<script>
import {
  GetOrderBill
} from '@/api/order.js'
export default {
  name: 'ShipmentCharges',
  components: {
    // 组件的引用
  },
  props: {
    // 父辈向子辈传参
  },
  data() {
    return {
      data: {},
      billData: {}
    }
  },
  computed: {
    // 计算属性
  },
  watch: {
    // 监测变化
  },
  created() {
    // 实例被创建之后执行代码
  },
  mounted() {
    // 页面进入时加载内容
  },
  methods: {
    // 方法
    init(data) {
      this.data = data
      GetOrderBill(this.data.orderNo).then(res => {
        if (res.code === 200) {
          this.billData = res.data
        }
      })
    }
  }
}
</script>
<style scoped lang='scss'>
	.shipmentCharges {
		width: 1152px;
		height: auto;
		background: #FFFFFF;
		border-radius: 8px;
		margin-top: 16px;
		padding: 20px 24px 24px;

		.title-class {
			font-size: 16px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 500;
			color: #333333;
			margin-bottom: 16px;
			text-align: left;
		}

		.card-mian {
			margin-bottom: 32px;
			display: flex;

			.card-item {
				width: 208px;
				height: 64px;
				background: rgba(0, 0, 0, 0.02);
				border-radius: 8px;
				margin-right: 24px;
				padding: 8px 16px;
				text-align: left;

				.card-name {
					height: 32px;
					line-height: 32px;
					font-size: 13px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 500;
					color: #8EC0F2;
				}

				.card-value {
					height: 32px;
					line-height: 32px;
					font-size: 16px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 500;
					color: #333333;
				}
			}
		}

		.list-main {
			table {
				width: 100%;
				border-collapse: collapse;
				text-align: left;
				padding: 0 8px;

				tr:nth-of-type(1) {
					background: #F7F7F7;
					height: 32px;

					td {
						font-size: 14px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 550;
						color: #777777;
						border-bottom: 0;
					}
				}

				tr {
					height: 40px;

					.text-left {
						text-align: left !important;
					}

					td {
						border-bottom: 1px solid rgba(170, 170, 170, 0.24);
						font-size: 14px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						color: #333333;
						padding: 0 16px;
					}

					td:last-child {
						text-align: right;
					}
				}
			}

			.total-main {
				text-align: right;

				.total {
					height: 40px;
					line-height: 40px;
					font-size: 14px;
					font-family: D-DINExp, D-DINExp;
					font-weight: bold;
					color: #333333;
				}
			}
		}
	}
</style>
